export function parseDate (time) {
  return time.slice(0, 10) + ' — ' + (Number(time.split('—')[1].trim().split('/')[0]) + 2) + '/' + time.slice(-5)
}



// WEBPACK FOOTER //
// ./src/utils/parseDate.js